import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import DetailItemsList from 'Components/ComponentLibrary/Organisms/DetailItemsList';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const DetailItems = ({
  collection,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  return (
    <DetailItemsList
      isButton={(resource) => {
        return resource.relationship(fr.relationships.subStep.name);
      }}
      onItemClick={(resource) => {
        loadModalCollectionByLink(resource.relationship(fr.relationships.subStep.name).link('related').url());
      }}
      collection={collection}
    />
  );
};

DetailItems.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default DetailItems;
